const navLinkStyledSignUp = {
  text: '¿Ya tiene una cuenta? Sign in'
};

export default navLinkStyledSignUp;
